import React from 'react';
import MenuMain from '../../MenuMain';
import { FormMudas } from '../../components/FormMudas';
import { AppFooter } from '../../AppFooter';


export default function CadastrarMudasPage() {

  const defaultValues = {
    'nome': '',

  }

  return (
    <div>
      <MenuMain>
         <FormMudas
          defaultValues={defaultValues}
        />
      </MenuMain>
      <AppFooter />
    </div>
  );
}

